import { useState, useEffect } from "react"
import { Alert, Container, Table } from "reactstrap"
import Utils from "../../../Utils"
import { Link } from "react-router-dom"

const PagosVencidos = () => {

    const [pagos, setPagos] = useState(null)

    const fetchPagos = async () => {
        try {
            const { data } = await Utils.API.PagosVencidos()
            setPagos(data)
        } catch(err) {
            Utils.AlertError(err, "No se pudo cargar los pagos del usuario")
        }
    }

    useEffect(() => {
        fetchPagos()
    }, [])


    return(
        <Container>
            {(pagos == null) ?
                <Alert className="text-center h3" color="info">Cargando...</Alert>
                :
                <>
                    {(pagos.length > 0) ?
                    <Table>
                        <thead>
                            <tr>
                                <th>Pago</th>
                                <th>Concepto</th>
                                <th>Monto</th>
                                <th>Vencimiento</th>
                                <th>Nombre</th>
                                <th>Celular</th>
                            </tr>
                        </thead>
                        <tbody>
                            {pagos.map(pago => (
                                <tr key={pago.idPago}>
                                    <td>
                                        <Link target="_blank" to={`/Ventas/Pagos/${pago.idUsuario}#Pago${pago.idPago}`}>
                                            <i className="fa-solid fa-up-right-from-square"></i> {pago.idPago}
                                        </Link>
                                    </td>
                                    <td>{pago.Concepto}</td>
                                    <td>{pago.Monto}</td>
                                    <td>{Utils.dayjs(pago.FechaExpiracion).format("L")}</td>
                                    <td>{pago.Nombre}</td>
                                    <td>
                                        <a href={`tel:${pago.Celular}`}>
                                            <i className="fa-solid fa-phone"></i> {pago.Celular}</a>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                    :
                    <Alert className="text-center">Sin pagos Vencidos</Alert>        
                    }
                </>
            }
        </Container>
    )
}

export default PagosVencidos